import { jsxs as _jsxs } from "react/jsx-runtime";
import _defineProperty from "/vercel/path1/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { FormControl, FormErrorMessage, FormHelperText, FormLabel, Input, Stack } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';

var isValidEmail = function isValidEmail(email) {
  return (// eslint-disable-next-line no-useless-escape
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)
  );
};

export var NewsletterForm = function NewsletterForm(props) {
  var _useForm = useForm(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.formState.errors;

  return /*#__PURE__*/_jsx("form", {
    onSubmit: handleSubmit(props.onSubmit),
    id: "join-newsletter",
    children: /*#__PURE__*/_jsxs(Stack, {
      children: [/*#__PURE__*/_jsxs(FormControl, {
        id: "name",
        isRequired: true,
        children: [/*#__PURE__*/_jsx(FormLabel, {
          children: "Name"
        }), /*#__PURE__*/_jsx(Input, _objectSpread({
          isRequired: true,
          type: "text",
          autoComplete: "name"
        }, register('name', {
          required: true
        })))]
      }), /*#__PURE__*/_jsxs(FormControl, {
        id: "email",
        isRequired: true,
        isInvalid: !!errors.email,
        children: [/*#__PURE__*/_jsx(FormLabel, {
          children: "Email address"
        }), /*#__PURE__*/_jsx(Input, _objectSpread({
          type: "email",
          autoComplete: "email"
        }, register('email', {
          required: true,
          validate: {
            isValidEmail: isValidEmail
          }
        }))), /*#__PURE__*/_jsx(FormHelperText, {
          children: "Only use your own email address."
        }), /*#__PURE__*/_jsx(FormErrorMessage, {
          children: "Enter a valid email"
        })]
      })]
    })
  });
};
export default NewsletterForm;